// src/features/ceiling/CeilingBar.tsx
import React from "react";
import { Group, Text, Divider } from "@mantine/core";
import { ModuleToolBarShell } from "../ModuleToolBarShell";
import { ActivateSnapSwitch } from "./ActivateSnapSwitch";
import { ActivateTrueSizeSwitch } from "./ActivateTrueSizeSwitch";

export const CeilingBar: React.FC = () => {
  return (
    <ModuleToolBarShell>
      <Group align="center" gap="md">
        {/* Tittel / kontekst */}
        <Group gap="sm" align="center">
          <Text fw={600} size="sm">
            Himlingsdesign
          </Text>
          <Divider orientation="vertical" h={24} />
        </Group>

        {/* Verktøy: snap to grid */}
        <ActivateSnapSwitch />
        <ActivateTrueSizeSwitch />
      </Group>
    </ModuleToolBarShell>
  );
};
